export default __webpack_public_path__ + "static/project-slide-6-415-700-14a811d95b28d50d9690e1375be3269f.webp";